
export const RESET_SALES_REP_CLASSIFICATION = 'RESET_SALES_REP_CLASSIFICATION';

// action types for Basic Details 
export const GET_BASIC_DETAILS = 'GET_BASIC_DETAILS'
export const GET_BASIC_DETAILS_SUCCESS = 'GET_BASIC_DETAILS_SUCCESS'
export const GET_BASIC_DETAILS_FAILURE = 'GET_BASIC_DETAILS_FAILURE'

export const GET_REVIEW_NEGOTIATION_DATA='GET_REVIEW_NEGOTIATION_DATA'
export const GET_REVIEW_NEGOTIATION_DATA_SUCCESS='GET_REVIEW_NEGOTIATION_DATA_SUCCESS'
export const GET_REVIEW_NEGOTIATION_DATA_FAILURE='GET_REVIEW_NEGOTIATION_DATA_FAILURE'

export const SAVE_REVIEW_NEGOTIATION_DATA='SAVE_REVIEW_NEGOTIATION_DATA'
export const SAVE_REVIEW_NEGOTIATION_DATA_SUCCESS='SAVE_REVIEW_NEGOTIATION_DATA_SUCCESS'
export const SAVE_REVIEW_NEGOTIATION_DATA_FAILURE='SAVE_REVIEW_NEGOTIATION_DATA_FAILURE'

export const GET_NEGOTIATION_ACTIONS = 'GET_NEGOTIATION_ACTIONS'
export const GET_NEGOTIATION_ACTIONS_SUCCESS = 'GET_NEGOTIATION_ACTIONS_SUCCESS'
export const GET_NEGOTIATION_ACTIONS_FAILURE = 'GET_NEGOTIATION_ACTIONS_FAILURE'
export const GET_AI_SUGGESTION_FOR_ACTION_CARDS = "GET_AI_SUGGESTION_FOR_ACTION_CARDS"
export const GET_AI_SUGGESTION_FOR_ACTION_CARDS_SUCCESS = "GET_AI_SUGGESTION_FOR_ACTION_CARDS_SUCCESS"
export const GET_AI_SUGGESTION_FOR_ACTION_CARDS_FAILURE = "GET_AI_SUGGESTION_FOR_ACTION_CARDS_FAILURE"

export const ADD_NEGOTIATION_ACTION = 'ADD_NEGOTIATION_ACTION'
export const ADD_NEGOTIATION_ACTION_SUCCESS = 'ADD_NEGOTIATION_ACTION_SUCCESS'
export const ADD_NEGOTIATION_ACTION_FAILURE = 'ADD_NEGOTIATION_ACTION_FAILURE'

export const DELETE_NEGOTIATION_ACTION = 'DELETE_NEGOTIATION_ACTION'
export const DELETE_NEGOTIATION_ACTION_SUCCESS = 'DELETE_NEGOTIATION_ACTION_SUCCESS'
export const DELETE_NEGOTIATION_ACTION_FAILURE = 'DELETE_NEGOTIATION_ACTION_FAILURE'

export const GET_NEGOTIATION_ACTION_RELATION ='GET_NEGOTIATION_ACTION_RELATION'
export const GET_NEGOTIATION_ACTION_RELATION_SUCCESS ='GET_NEGOTIATION_ACTION_RELATION_SUCCESS'
export const GET_NEGOTIATION_ACTION_RELATION_FAILURE ='GET_NEGOTIATION_ACTION_RELATION_FAILURE'

export const SAVE_DOCUMENT_OUTCOME = 'SAVE_DOCUMENT_OUTCOME'
export const SAVE_DOCUMENT_OUTCOME_SUCCESS = 'SAVE_DOCUMENT_OUTCOME_SUCCESS'
export const SAVE_DOCUMENT_OUTCOME_FAILURE = 'SAVE_DOCUMENT_OUTCOME_FAILURE'

export const GET_DOCUMENT_OUTCOME='GET_DOCUMENT_OUTCOME'
export const GET_DOCUMENT_OUTCOME_SUCCESS='GET_DOCUMENT_OUTCOME_SUCCESS'
export const GET_DOCUMENT_OUTCOME_FAILURE='GET_DOCUMENT_OUTCOME_FAILURE'

export const CREATE_NEW_SUPPLIER = 'CREATE_NEW_SUPPLIER'
export const CREATE_NEW_SUPPLIER_SUCCESS = 'CREATE_NEW_SUPPLIER_SUCCESS'
export const CREATE_NEW_SUPPLIER_FAILURE = 'CREATE_NEW_SUPPLIER_FAILURE'

export const DELETE_SUPPLIER = 'DELETE_SUPPLIER'
export const DELETE_SUPPLIER_SUCCESS = 'DELETE_SUPPLIER_SUCCESS'
export const DELETE_SUPPLIER_FAILURE = 'DELETE_SUPPLIER_FAILURE'

export const CREATE_NEW_SALES_REP_LEAD = 'CREATE_NEW_SALES_REP_LEAD'
export const CREATE_NEW_SALES_REP_LEAD_SUCCESS = 'CREATE_NEW_SALES_REP_LEAD_SUCCESS'
export const CREATE_NEW_SALES_REP_LEAD_FAILURE = 'CREATE_NEW_SALES_REP_LEAD_FAILURE'

export const DELETE_SALES_REP_LEAD = 'DELETE_SALES_REP_LEAD'
export const DELETE_SALES_REP_LEAD_SUCCESS = 'DELETE_SALES_REP_LEAD_SUCCESS'
export const DELETE_SALES_REP_LEAD_FAILURE = 'DELETE_SALES_REP_LEAD_FAILURE'

// action types for basdic details dropdown 
export const GET_BASIC_DETAILS_DROPDOWN_API = "GET_BASIC_DETAILS_DROPDOWN_API"

// action types for power position
export const GET_POWER_POSITION = "GET_POWER_POSITION";
export const GET_POWER_POSITION_SUCCESS = "GET_POWER_POSITION_SUCCESS";
export const GET_POWER_POSITION_FAILURE = "GET_POWER_POSITION_FAILURE";
export const SET_POWER_POSITION = "SET_POWER_POSITION";
export const GET_AI_SUGGESTION_DATA_POWER_POSITION = "GET_AI_SUGGESTION_DATA_POWER_POSITION"
export const GET_AI_SUGGESTION_DATA_POWER_POSITION_SUCCESS = "GET_AI_SUGGESTION_DATA_POWER_POSITION_SUCCESS"
export const GET_AI_SUGGESTION_DATA_POWER_POSITION_FAILURE = "GET_AI_SUGGESTION_DATA_POWER_POSITION_FAILURE"
export const SET_POWER_POSITION_ID = "SET_POWER_POSITION_ID"
export const GET_POWER_POSITION_LIST = "GET_POWER_POSITION_LIST"
export const GET_POWER_POSITION_LIST_SUCCESS = "GET_POWER_POSITION_LIST_SUCCESS"
export const GET_POWER_POSITION_LIST_FAILURE = "GET_POWER_POSITION_LIST_FAILURE"

// action types for sales rep classification 
export const SET_CLASSIFICATION_TYPE = 'SET_CLASSIFICATION_TYPE';
export const SET_CLASSIFICATION_QUESTIONNAIRE = 'SET_CLASSIFICATION_QUESTIONNAIRE';
export const RESET_POWER_POSITION = 'RESET_POWER_POSITION'
export const RESET_BASIC_DETAILS = "RESET_BASIC_DETAILS";
export const RESET_TARGET_VALUE_DETAILS = "RESET_TARGET_VALUE_DETAILS";
export const RESET_SELECTED_ACTION_TILES = "RESET_SELECTED_ACTION_TILES";
export const SET_SALES_REP_CLASSIFICATION_ID = "SET_SALES_REP_CLASSIFICATION_ID"
export const POST_SAVE_FORM_DETAILS = 'POST_SAVE_FORM_DETAILS'
export const GET_SALES_REP_CLASSIFICATION_LIST = "GET_SALES_REP_CLASSIFICATION_LIST"
export const GET_SALES_REP_CLASSIFICATION_LIST_SUCCESS = "GET_SALES_REP_CLASSIFICATION_LIST_SUCCESS"
export const GET_SALES_REP_CLASSIFICATION_LIST_FAILURE = "GET_SALES_REP_CLASSIFICATION_LIST_FAILURE"

//action types for countries fields from basic details
export const GET_BASIC_DETAILS_COUNTRIES = 'GET_BASIC_DETAILS_COUNTRIES'
export const GET_BASIC_DETAILS_COUNTRIES_SUCCESS = 'GET_BASIC_DETAILS_COUNTRIES_SUCCESS'
export const GET_BASIC_DETAILS_COUNTRIES_FAILURE = 'GET_BASIC_DETAILS_COUNTRIES_FAILURE'

export const GET_ENTRA_ID_USERS = "GET_ENTRA_ID_USERS"
export const GET_ENTRA_ID_USERS_SUCCESS ="GET_ENTRA_ID_USERS_SUCCESS"
export const GET_ENTRA_ID_USERS_FAILURE ="GET_ENTRA_ID_USERS_FAILURE"

export const GET_SALES_REP_CLASSIFICATIONS='GET_SALES_REP_CLASSIFICATIONS'
export const GET_SALES_REP_CLASSIFICATIONS_SUCCESS='GET_SALES_REP_CLASSIFICATIONS_SUCCESS'
export const GET_SALES_REP_CLASSIFICATIONS_FAILURE='GET_SALES_REP_CLASSIFICATIONS_FAILURE'

// action types for categories fields from basic details
export const GET_BASIC_DETAILS_CATAGORIES = 'GET_BASIC_DETAILS_CATAGORIES'
export const GET_BASIC_DETAILS_CATAGORIES_SUCCESS = 'GET_BASIC_DETAILS_CATAGORIES_SUCCESS'
export const GET_BASIC_DETAILS_CATAGORIES_FAILURE = 'GET_BASIC_DETAILS_CATAGORIES_FAILURE'

// action types for sales rep lead fields from basic details
export const GET_BASIC_DETAILS_SALESREPLEAD = 'GET_BASIC_DETAILS_SALESREPLEAD'
export const GET_BASIC_DETAILS_SALESREPLEAD_SUCCESS = 'GET_BASIC_DETAILS_SALESREPLEAD_SUCCESS'
export const GET_BASIC_DETAILS_SALESREPLEAD_FAILURE = 'GET_BASIC_DETAILS_SALESREPLEAD_FAILURE'

export const GET_BASIC_DETAILS_SUPPLIERS = 'GET_BASIC_DETAILS_SUPPLIERS'
export const GET_BASIC_DETAILS_SUPPLIERS_SUCCESS = 'GET_BASIC_DETAILS_SUPPLIERS_SUCCESS'
export const GET_BASIC_DETAILS_SUPPLIERS_FAILURE = 'GET_BASIC_DETAILS_SUPPLIERS_FAILURE'

// action types for Target values
export const GET_TARGET_VALUE_DETAILS = "GET_TARGET_VALUE_DETAILS";
export const GET_TARGET_VALUE_DETAILS_SUCCESS = "GET_TARGET_VALUE_DETAILS_SUCCESS";
export const GET_TARGET_VALUE_DETAILS_FAILURE = "GET_TARGET_VALUE_DETAILS_FAILURE";

export const GET_SELECTED_ACTION_TILES = "GET_SELECTED_ACTION_TILES";
export const GET_SELECTED_ACTION_TILES_SUCCESS = "GET_SELECTED_ACTION_TILES_SUCCESS";
export const GET_SELECTED_ACTION_TILES_FAILURE = "GET_SELECTED_ACTION_TILES_FAILURE";

export const SAVE_NEGOTIATION_ROUND_ACTIONS = "SAVE_NEGOTIATION_ROUND_ACTIONS";

// action types for toast message
export const API_CALL_REQUEST = "API_CALL_REQUEST";
export const API_CALL_SUCCESS = "API_CALL_SUCCESS";
export const API_CALL_FAILURE = "API_CALL_FAILURE";
export const CLEAR_API_CALL_MESSAGE = "CLEAR_API_CALL_MESSAGE";

// action types for sales rep classification AI data
export const GET_AI_RECOMMENDATION_SALES_REP_CLASSIFICATION = "GET_AI_RECOMMENDATION_SALES_REP_CLASSIFICATION";
export const GET_AI_RECOMMENDATION_SALES_REP_CLASSIFICATION_SUCCESS = "GET_AI_RECOMMENDATION_SALES_REP_CLASSIFICATION_SUCCESS";
export const GET_AI_RECOMMENDATION_SALES_REP_CLASSIFICATION_FAILURE = "GET_AI_RECOMMENDATION_SALES_REP_CLASSIFICATION_FAILURE";


export const CREATE_NEGOTIATION = "CREATE_NEGOTIATION";
export const CREATE_NEGOTIATION_SUCCESS = "CREATE_NEGOTIATION_SUCCESS";
export const CREATE_NEGOTIATION_FAILURE = "CREATE_NEGOTIATION_FAILURE";


// action types for profile page
export const GET_PROFILE_DETAILS = "GET_PROFILE_DETAILS";
export const GET_PROFILE_DETAILS_SUCCESS = "GET_PROFILE_DETAILS_SUCCESS";
export const GET_PROFILE_DETAILS_FAILURE = "GET_PROFILE_DETAILS_FAILURE";

// action types for profile page save
export const SAVE_PROFILE_DETAILS = "SAVE_PROFILE_DETAILS";
export const SAVE_PROFILE_DETAILS_SUCCESS = "SAVE_PROFILE_DETAILS_SUCCESS";
export const SAVE_PROFILE_DETAILS_FAILURE = "SAVE_PROFILE_DETAILS_FAILURE";

// action types for updating profile update
export const UPDATE_PROFILE_DETAILS = "UPDATE_PROFILE_DETAILS";
export const UPDATE_PROFILE_DETAILS_SUCCESS = "UPDATE_PROFILE_DETAILS_SUCCESS";
export const UPDATE_PROFILE_DETAILS_FAILURE = "UPDATE_PROFILE_DETAILS_FAILURE";
// action types for Overview data fetch
export const GET_ALL_NEGOTIATION_CONTRACTS = "GET_ALL_NEGOTIATION_CONTRACTS";
export const GET_ALL_NEGOTIATION_CONTRACTS_SUCCESS = "GET_ALL_NEGOTIATION_CONTRACTS_SUCCESS";
export const GET_ALL_NEGOTIATION_CONTRACTS_FAILURE = "GET_ALL_NEGOTIATION_CONTRACTS_FAILURE";

// action types of negotiation tile for draft flow 
export const GET_NEGOTIATION_TILE_DETAILS = "GET_NEGOTIATION_TILE_DETAILS";
export const GET_NEGOTIATION_TILE_DETAILS_SUCCESS = "GET_NEGOTIATION_TILE_DETAILS_SUCCESS";
export const GET_NEGOTIATION_TILE_DETAILS_FAILURE = "GET_NEGOTIATION_TILE_DETAILS_FAILURE";

export const SET_NEGOTIATION_CONTRACT_STATUS = "SET_NEGOTIATION_CONTRACT_STATUS";
export const RESET_API_LOADER = "RESET_API_LOADER";

// action types for detailed negotiation overview page
export const GET_DETAILED_NEGOTIATION_OVERVIEW_SUCCESS = "GET_DETAILED_NEGOTIATION_OVERVIEW_SUCCESS";
export const POST_DETAILED_NEGOTIATION_OVERVIEW = "POST_DETAILED_NEGOTIATION_OVERVIEW"
export const RESET_DETAILED_NEGOTIATION_OVERVIEW = "RESET_DETAILED_NEGOTIATION_OVERVIEW";
export const SET_IS_DATA_UPDATED = "SET_IS_DATA_UPDATED";
export const SET_EXIT_STATUS_DETIALED_OVERVIEW = "SET_EXIT_STATUS_DETIALED_OVERVIEW";
export const SET_CLOSE_NEGOTIATION_CONTRACT_DATA = "SET_CLOSE_NEGOTIATION_CONTRACT_DATA";

// action types for close negotiation page 
export const GET_AI_SUMMARY_FOR_CLOSE_NEGOTIATION = "GET_AI_SUMMARY_FOR_CLOSE_NEGOTIATION"
export const GET_AI_SUMMARY_FOR_CLOSE_NEGOTIATION_SUCCESS = "GET_AI_SUMMARY_FOR_CLOSE_NEGOTIATION_SUCCESS"
export const GET_AI_SUMMARY_FOR_CLOSE_NEGOTIATION_FAILURE = "GET_AI_SUMMARY_FOR_CLOSE_NEGOTIATION_FAILURE"
export const RESET_AI_SUMMARY_FOR_CLOSE_NEGOTIATION = "RESET_AI_SUMMARY_FOR_CLOSE_NEGOTIATION"

//action types for save detailed negotiation overview 
export const UPDATE_DETAILED_NEGOTIATION_OVERVIEW = "UPDATE_DETAILED_NEGOTIATION_OVERVIEW"